
export default {
    data() {
        return {
            cols: ['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-'],
            matrix: [],
            list_komponen: [],
            selectedTahun: new Date().getFullYear(),
            saving: false,
            loading: false
        }
    },

    computed: {
        tahunOptions() {
            const current = new Date().getFullYear();
            const options = [];
            for (let y = current - 2; y <= current + 5; y++) {
                options.push(y);
            }
            return options;
        },

        groupTotals() {
            const totals = { A: 0, B: 0, O: 0, AB: 0, Total: 0 }
            if (!Array.isArray(this.matrix)) return totals

            this.matrix.forEach(row => {
                const aPlus = Number(row['A+'] || 0)
                const aMin = Number(row['A-'] || 0)
                const bPlus = Number(row['B+'] || 0)
                const bMin = Number(row['B-'] || 0)
                const oPlus = Number(row['O+'] || 0)
                const oMin = Number(row['O-'] || 0)
                const abPlus = Number(row['AB+'] || 0)
                const abMin = Number(row['AB-'] || 0)

                totals.A += aPlus + aMin
                totals.B += bPlus + bMin
                totals.O += oPlus + oMin
                totals.AB += abPlus + abMin
                totals.Total += Number(row.Total || 0)
            })

            return totals
        }
    },

    methods: {
        // === Recalculate row total ===
        recalcTotal(row) {
            let total = 0;
            this.cols.forEach(col => {
                total += Number(row[col] || 0);
            });
            row.Total = total;
        },

        // === Ambil daftar komponen ===
        getKomponen() {
            fetch(this.$store.state.url.KOMPONEN + "view", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({})
            })
                .then(res => res.json())
                .then(res_data => {
                    this.list_komponen = res_data.data || []
                    this.buildMatrix()
                })
                .catch(err => console.error("Error getKomponen:", err))
        },

        // === Build matrix dari komponen, lalu overlay data rencana ===
        buildMatrix() {
            // Buat matrix kosong dari daftar komponen
            const map = {};
            this.list_komponen.forEach(k => {
                const key = k.nama_komponen;
                if (!map[key]) {
                    map[key] = { Komponen: key, komponen_id: k.id, Total: 0 };
                    this.cols.forEach(c => { map[key][c] = 0; });
                }
            });

            this.matrix = Object.values(map).sort((a, b) => a.Komponen.localeCompare(b.Komponen));

            // Fetch existing rencana dan overlay
            this.fetchRencana();
        },

        // === Ambil data rencana yang sudah ada ===
        fetchRencana() {
            this.loading = true;
            this.$store.commit("shoWLoading");

            const url = this.$store.state.url.RENCANA_KEBUTUHAN + "view?tahun=" + this.selectedTahun;

            fetch(url, {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }
            })
                .then(res => res.json())
                .then(res_data => {
                    if (res_data.success && Array.isArray(res_data.data)) {
                        // Overlay data rencana ke matrix
                        res_data.data.forEach(r => {
                            const gol = (r.golongan_darah || '').toString().trim().toUpperCase();
                            const rhes = (r.rhesus || '').toString().trim();
                            const colKey = `${gol}${rhes}`;
                            const komponen = r.nama_komponen || '';

                            const row = this.matrix.find(m => m.Komponen === komponen);
                            if (row && this.cols.includes(colKey)) {
                                row[colKey] = Number(r.jumlah || 0);
                            }
                        });

                        // Recalculate totals
                        this.matrix.forEach(row => this.recalcTotal(row));
                    }
                })
                .catch(err => {
                    console.error("fetchRencana error", err);
                })
                .finally(() => {
                    this.loading = false;
                    this.$store.commit("hideLoading");
                });
        },

        // === Trigger ulang saat ganti tahun ===
        fetchMatrix() {
            this.buildMatrix();
        },

        // === Simpan semua rencana ===
        saveAll() {
            this.saving = true;
            this.$store.commit("shoWLoading");

            const items = [];
            this.matrix.forEach(row => {
                this.cols.forEach(col => {
                    // Parse golongan dan rhesus dari col key
                    let gol, rhesus;
                    if (col.startsWith('AB')) {
                        gol = 'AB';
                        rhesus = col.substring(2);
                    } else {
                        gol = col.substring(0, 1);
                        rhesus = col.substring(1);
                    }

                    items.push({
                        golongan_darah: gol,
                        rhesus: rhesus,
                        komponen_id: row.komponen_id,
                        jumlah: Number(row[col] || 0)
                    });
                });
            });

            fetch(this.$store.state.url.RENCANA_KEBUTUHAN + "save", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    tahun: this.selectedTahun,
                    items: items
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    if (res_data.success) {
                        this.$q.notify({
                            type: "positive",
                            message: res_data.message || "Rencana kebutuhan darah berhasil disimpan"
                        });
                    } else {
                        this.$q.notify({
                            type: "negative",
                            message: res_data.message || "Gagal menyimpan rencana"
                        });
                    }
                })
                .catch(err => {
                    console.error("saveAll error", err);
                    this.$q.notify({
                        type: "negative",
                        message: "Terjadi kesalahan saat menyimpan rencana"
                    });
                })
                .finally(() => {
                    this.saving = false;
                    this.$store.commit("hideLoading");
                });
        },

        // === FORMAT ANGKA ===
        formatNumber(n) {
            const v = Number(n)
            return isNaN(v) ? (n ?? '-') : v.toLocaleString('id-ID')
        },
    },

    mounted() {
        this.getKomponen();
    }
}
